import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsothermalCharacterizationListComponent } from './isothermal-characterization-list.component';
import { IsothermalCharacterizationListFilterComponent } from './isothermal-characterization-list-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { SharedModule } from '../../shared/shared.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [IsothermalCharacterizationListComponent, IsothermalCharacterizationListFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,

    /* Otros */
    FlexLayoutModule,
    RouterModule
  ]
})
export class IsothermalCharacterizationListModule { }
